import React, {useEffect, useState} from 'react'
import { getImages } from '../../Common/const';
import { Formik, Field, FieldArray, Form } from 'formik';

export const UpdateEquipmentItem = ({ getVehicleDescriptions, getVehicleData, filteredVehicleData, numberFormatter, vehicleDescriptionModify }) => {

    const [vehicleDescriptions, setVehicleDescriptions] = useState([]);

    const handleInputChange = (input_id, field, value) => {

        if(field == "bold") boldDescription(input_id,value);

        setVehicleDescriptions(prevItems =>
            prevItems.map(item =>
                item.id === input_id ? { ...item, [field]: value } : item
            )
        );
    };

    const addDescription = async (vin,description) => {
        const data = await vehicleDescriptionModify({'action':'add_description','vin':vin,'description':description});

        if(data) setVehicleDescriptions(data);
    }

    const removeDescription = (input_id) => {
        vehicleDescriptionModify({'action':'remove_description','id':input_id});

        setVehicleDescriptions(prevItems =>
            prevItems.filter(item => item.id != input_id)
        );
    }

    const boldDescription = (id,bold) => {
        vehicleDescriptionModify({'action':'bold_description','id':id,'bold':bold});
    }

    const updateDescription = (id,description) => {
        vehicleDescriptionModify({'action':'update_description','id':id,'description':description});
    }
    
    const fetchDescriptions = async () => {
        const data = await getVehicleDescriptions();
    
        setVehicleDescriptions(data);
    }
      
    useEffect(() => {
        getVehicleData();
        fetchDescriptions();
    },[]);

    return (
        <>
            <div className="accordion ue-accordion" id="accordionExample">
                <table className='w-100 ue-main-table'>
                    <thead>
                        <tr>
                            <th style={{ width: '5%' }}>&nbsp;</th>
                            <th style={{ width: '36%' }}>Vehicle</th>
                            <th style={{ width: '13%' }} className='text-center'>Price</th>
                            <th style={{ width: '13%' }} className='text-center'>Miles</th>
                            <th style={{ width: '13%' }} className='text-center'>Stock #</th>
                            {/*<th style={{ width: '20%' }} className='text-end'>&nbsp;</th>*/}
                        </tr>
                    </thead>
                </table>
                {filteredVehicleData && filteredVehicleData.map((item, index) => {
                    const headingId = `heading${index}`;
                    const collapseId = `collapse${index}`;
                    const isExpanded = item.show ? 'true' : 'false';
                    const buttonClass = item.show ? 'accordion-button' : 'accordion-button collapsed';
                    const collapseClass = item.show ? 'accordion-collapse collapse show' : 'accordion-collapse collapse';
                    // console.log("item.id", item.id)
                    return (
                        <div className="accordion-item" key={index}>
                            <table className='w-100 ue-main-table'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '5%' }}>
                                            <h2 className="accordion-header" id={headingId}>
                                                <button
                                                    className={buttonClass}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#${collapseId}`}
                                                    aria-expanded={isExpanded}
                                                    aria-controls={collapseId}
                                                >
                                                    <img src={getImages('admin/ue-arrow-icon.svg')} alt='icon' />
                                                </button>
                                            </h2>
                                        </td>
                                        <td style={{ width: '36%' }}>
                                            <div className='xs-title text-blue'>{item.vehicle_name}</div>
                                        </td>
                                        <td style={{ width: '13%' }} className='text-center'><div className='xs-title'>{numberFormatter(item.price,true)}</div></td>
                                        <td style={{ width: '13%' }} className='text-center'>{numberFormatter(item.mileage)}</td>
                                        <td style={{ width: '13%' }} className='text-center'>{item.stockno}</td>
                                        {/*<td style={{ width: '20%' }} className='text-end'>
                                            <button type='button' className='theme-sm-btn text-uppercase mnw-150'>Vehicle Sold</button>
                                        </td>*/}
                                    </tr>
                                </tbody>
                            </table>
                            <div
                                id={collapseId}
                                className={collapseClass}
                                aria-labelledby={headingId}
                                data-bs-parent="#accordionExample"
                            >
                                <div
                                    className="accordion-body px-0"
                                >
                                    <Formik
                                        initialValues={{
                                            equipments: [
                                                { name: '', bold: false },
                                            ],
                                        }}
                                        onSubmit={values => {
                                            console.log(values);
                                        }}
                                    >
                                        {({ values }) => (
                                            <Form>
                                                <table className='w-100 ue-inner-table'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '80%' }}>Add Equipment</th>
                                                            <th style={{ width: '10%' }} className='text-center'>Bold</th>
                                                            <th style={{ width: '10%' }} className='text-center'>Delete</th>
                                                        </tr>
                                                    </thead>
                                                        <tbody>
                                                            {vehicleDescriptions && vehicleDescriptions.filter((description) => item.vin == description.vin).map((description, d_index) => (
                                                                <tr key={d_index}>
                                                                    <td>
                                                                        <Field 
                                                                            name={`equipments.${d_index}.name`} 
                                                                            type="text" 
                                                                            className="form-control" 
                                                                            value={description.description}
                                                                            onChange={(e) => {handleInputChange(description.id, 'description', e.target.value)}}
                                                                            onBlur={(e) => {updateDescription(description.id,e.target.value)}}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div className="custom-checkbox ss-checkbox">
                                                                            <Field
                                                                                type="checkbox"
                                                                                name={`equipments.${d_index}.bold`}
                                                                                id={`${item.id}-boldItem-${d_index}`}
                                                                                checked={description.bold == 1}
                                                                                onChange={(e) => {handleInputChange(description.id, 'bold', e.target.checked ? 1 : 0)}}
                                                                            />
                                                                            <label htmlFor={`${item.id}-boldItem-${d_index}`} className="w-100" />
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <button
                                                                            type="button"
                                                                            className="ad-trans-btn"
                                                                            onClick={() => {removeDescription(description.id)}}
                                                                        >
                                                                            <img className="d-block" src={getImages('admin/trash-icon.svg')} alt="delete" />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                            <tr>
                                                                <td colSpan="3" className="ps-29">
                                                                    <button
                                                                        type="button"
                                                                        className="ad-trans-btn text-uppercase text-blue xs-title pt-0"
                                                                        onClick={() => {addDescription(item.vin,'')}}
                                                                    >
                                                                        <img
                                                                            className="d-inline-block"
                                                                            src={getImages('admin/plus-icon.svg')}
                                                                            alt="add"
                                                                        />
                                                                        Add Row
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                </table>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    )
}
